import React, { FormEventHandler, useCallback, useState } from 'react';
import { Input, Button } from '@hugendubel/react-basic';
import { PointLimit, SearchService } from '../../../services/search-service';
import { useNavigate } from 'react-router-dom';

export const SearchByEan: React.FC = () => {
    const navigate = useNavigate();
    const [ean, setEan] = useState('');

    const onSubmit = useCallback<FormEventHandler<HTMLFormElement>>(
        e => {
            e.preventDefault();
            navigate(SearchService.calculateUrl({ ean, pf: undefined, page: 1, show: PointLimit.ALL }));
        },
        [ean, navigate]
    );

    const onChange = useCallback(
        (value: string): void => {
            if (!value) {
                navigate(SearchService.calculateUrl({ ean: undefined }));
            }
            setEan(value);
        },
        [navigate]
    );

    return (
        <form onSubmit={onSubmit} className="ean-search-form">
            <Input
                className="ean-search-field"
                value={ean}
                onChange={onChange}
                placeholder="page.Home.eanFilter.placeholder"
            />
            <Button disabled={!ean} className="btn btn-default" label="page.Home.eanFilter.submit" />
        </form>
    );
};
